import { gsap } from '@gsap/shockingly';
import { ScrollTrigger } from '@gsap/shockingly/ScrollTrigger';
import { SplitText } from "@gsap/shockingly/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);


const scrollAnimations = {
	ui: {},

	init: function() {
		this.bindUI();
		this.handleTextAnimations();
        this.initEffects();
	},

	bindUI: function() {
		this.ui.$splitText = document.querySelectorAll('.js-splitText');
	},

    /**
     * @function handleTextAnimations
     * split text into words and create timelines
     */
	handleTextAnimations: function() {

        this.ui.$splitText.forEach(item => {
            let mySplitText = new SplitText(item, {
                type: 'words',
                wordsClass: 'splitText__word js-splitText-word'
            });
            mySplitText.words[0].classList.add('blockTitle__description__textIndent');
            this.createTextTimelines(item);
        });

	},

    /**
     * @function createTextTimelines
     * @param {HTMLDivElement} trigger 
     */
    createTextTimelines: function(trigger) {
        const words = trigger.querySelectorAll('.js-splitText-word')

        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: trigger,
                start: 'center bottom-=5%',
            }
        })

        timeline
            .from(trigger,  {
                ease: 'power2.out',
                autoAlpha: 0,
                duration: 0
            }).from(words,  {
                ease: 'power2.out',
                y: 100,
                stagger: 0.015,
                autoAlpha: 0,
                duration: 0.8
            });
    },

    /**
     * @function initEffects
     * Init all scroll animations effects
     */
    initEffects: function() {
        this.handleStaggerFade();
        this.handleFade()
    },

    /**
     * @function handleStaggerFade
     * Handle stagger fade : fade animation for list
     */
    handleStaggerFade: function() {
        const blocks = document.querySelectorAll('[data-stagger-fade]');

        blocks.forEach(block => {
            const items = block.querySelectorAll('[data-stagger-item]');

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: block,
                    start: 'top+=25% bottom',
                }
            })

            timeline.fromTo(items,  {
                autoAlpha: 0,
                y: 40
            }, {
                ease: 'circ.out',
                autoAlpha: 1,
                duration: 0.8,
                y:0,
                stagger: 0.10,
            });
        });
    },

    /**
     * @function handleFade
     * Handle fade : fade animation for block
     */
    handleFade: function() {
        const blocks = document.querySelectorAll('[data-fade]');

        blocks.forEach(block => {
            const trigger = block.dataset.trigger ? block.closest(block.dataset.trigger) : block;
            const delay = block.dataset.delay ? parseFloat(block.dataset.delay) : 0;
            const duration = block.dataset.duration ? parseFloat(block.dataset.duration) : 0.8;

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: trigger,
                    start: 'top+=30% bottom'
                }
            })

            timeline.fromTo(block,  {
                autoAlpha: 0,
                y: 40
            }, {
                autoAlpha: 1,
                y: 0,
                duration: duration,
                delay: delay,
                ease: 'circ.out'
            });
        });
    }
};

export default scrollAnimations;
